export default "__VITE_ASSET__a6ffb1ed__"